import React from 'react'
import '../styles/APNav.css'
import attendance_platform_logo from '../../../Assets/attendance_platform_logo.png'
import { Nav, Navbar } from 'react-bootstrap'

export const APNavBar = ({visibleNavLinks}) => {
  return (
    <div>
      <Navbar
        className="root-nav"
        collapseOnSelect
        style={{ backgroundColor: '#291d42', color: 'black' }}
        variant="dark"
        expand="lg"
        fill
      >
        <Navbar.Brand className="navbar-brand ml-4">
          <img
            style={{ height:'3rem', width: '3rem' }}
            src={attendance_platform_logo}
            alt=""
            className="d-inline-block align-middle mr-2"
          />
          {' '}
          Attendance Platform
        </Navbar.Brand>

        { visibleNavLinks &&  
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
} 
 { visibleNavLinks &&  
                             
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto " fill>

            <Nav.Link className='hover' href='#features1'>Features</Nav.Link>
            <Nav.Link className='hover' href='#download'>Download</Nav.Link>
            <Nav.Link className='hover' href='#features2'>About</Nav.Link>

              {/* <LinkContainer className="hover" to="/contact">
                <Nav.Link style={{ marginTop: '7px', marginRight: '7px' }}>
                  Contact Us
                </Nav.Link>
              </LinkContainer> */}
            </Nav>
          </Navbar.Collapse>
        }
      </Navbar>
    </div>
  )
}
